import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { baseUrl, getConfigWithToken } from '../config/config';
import { toast } from 'react-toastify';
import { IoIosArrowBack } from 'react-icons/io'; // Ensure this exists, or use a custom SVG

const AddInsurance = () => {
    const navigate = useNavigate();
    const user = useSelector((state) => state?.user);
    const token = user?.token || localStorage.getItem("token") || localStorage.getItem("user_id");

    const [formData, setFormData] = useState({
        insurance_name: '',
        payer_id: '',
        status: 'active'
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = async () => {
        if (!formData.insurance_name.trim()) {
            toast.error("Insurance Name is required");
            return;
        }

        setLoading(true);
        try {
            const config = getConfigWithToken(token);
            const res = await axios.post(`${baseUrl}insuranceProvider/create`, formData, config);

            if (res.data && res.data.success) {
                toast.success("Insurance added successfully");
                navigate('/payer-matrix', { state: { activeTab: 'Insurances' } });
            } else {
                toast.error(res.data?.message || "Failed to add insurance");
            }
        } catch (error) {
            console.error("Error creating insurance:", error);
            toast.error(error.response?.data?.message || "An error occurred while adding insurance");
        } finally {
            setLoading(false);
        }
    };

    const containerStyle = {
        padding: '20px',
        backgroundColor: '#f8f9fa',
        minHeight: '100vh',
        fontFamily: "'Poppins', sans-serif",
    };

    const headerStyle = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '15px 25px',
        backgroundColor: '#FFFFFF',
        borderRadius: '12px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
        marginBottom: '20px',
    };

    const backButtonStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        cursor: 'pointer',
        color: '#28BDAD',
        fontWeight: '600',
        fontSize: '14px',
        background: 'none',
        border: 'none',
        padding: 0,
    };

    const backIconContainerStyle = {
        backgroundColor: '#28BDAD',
        color: '#FFFFFF',
        borderRadius: '50%',
        width: '30px',
        height: '30px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '18px',
    };

    const saveButtonStyle = {
        padding: '10px 30px',
        backgroundColor: '#1E4A5F',
        color: '#FFFFFF',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '600',
        transition: 'background-color 0.2s',
    };

    const cardStyle = {
        backgroundColor: '#FFFFFF',
        borderRadius: '12px',
        padding: '30px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
    };

    const titleStyle = {
        fontSize: '24px',
        fontWeight: '700',
        color: '#000000',
        marginBottom: '30px',
        marginTop: 0,
    };

    const formGroupStyle = {
        marginBottom: '20px',
    };

    const labelStyle = {
        display: 'block',
        fontSize: '14px',
        fontWeight: '600',
        color: '#333333',
        marginBottom: '8px',
    };

    const inputStyle = {
        width: '100%',
        padding: '12px 15px',
        borderRadius: '8px',
        border: '1px solid #ced4da',
        fontSize: '15px',
        color: '#495057',
        outline: 'none',
        transition: 'border-color 0.2s',
        boxSizing: 'border-box',
    };

    return (
        <div style={containerStyle}>
            {/* Header Area */}
            <div style={headerStyle}>
                <button style={backButtonStyle} onClick={() => navigate(-1)}>
                    <div style={backIconContainerStyle}>
                        <IoIosArrowBack />
                    </div>
                    <span>Back</span>
                </button>
                <button
                    style={{ ...saveButtonStyle, opacity: loading ? 0.7 : 1 }}
                    onClick={handleSave}
                    disabled={loading}
                >
                    {loading ? 'Saving...' : 'Save'}
                </button>
            </div>

            {/* Form Card */}
            <div style={cardStyle}>
                <h1 style={titleStyle}>Add Insurance</h1>

                <div style={formGroupStyle}>
                    <label style={labelStyle}>Insurance Name</label>
                    <input
                        type="text"
                        name="insurance_name"
                        value={formData.insurance_name}
                        onChange={handleChange}
                        placeholder="Enter Insurance Name"
                        style={inputStyle}
                    />
                </div>

                <div style={formGroupStyle}>
                    <label style={labelStyle}>Payer ID</label>
                    <input
                        type="text"
                        name="payer_id"
                        value={formData.payer_id}
                        onChange={handleChange}
                        placeholder="Payer ID"
                        style={inputStyle}
                    />
                </div>

                <div style={formGroupStyle}>
                    <label style={labelStyle}>Status</label>
                    <select
                        name="status"
                        value={formData.status}
                        onChange={handleChange}
                        style={inputStyle}
                    >
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                    </select>
                </div>
            </div>
        </div>
    );
};

export default AddInsurance;
